import { useResetAtom } from 'jotai/utils'
import { useUnmount } from 'react-use'

import { highlightedCellAtom } from '~/atoms/highlightedCellAtom'

import {
  commentAtom,
  customerAttributeIdsAtom,
  dataDisplayTypeAtom,
  groupAtom,
  groupInfosAtom,
  groupNameMapAtom,
  groupsDiffsAtom,
  hiddenColumnKeysAtom,
  hiddenRowIdsAtom,
  individualSortValueAtom,
  isPendingTabulationAtom,
  isTabulationReadyAtom,
  lastTabulatedVariablesAtom,
  matrixSortValueAtom,
  questionIdsAtom,
  questionsDiffsMapAtom,
  resultViewerTypeAtom,
  savedCommentAtom,
  sequentialSortValueAtom,
  tabulationQueryDataAtom,
} from '../atoms'

export const useResetOnUnmount = () => {
  const resetComment = useResetAtom(commentAtom)
  const resetSavedComment = useResetAtom(savedCommentAtom)
  const resetDataDisplayType = useResetAtom(dataDisplayTypeAtom)
  const resetGroupInfos = useResetAtom(groupInfosAtom)
  const resetResultViewerType = useResetAtom(resultViewerTypeAtom)
  const resetQuestionIds = useResetAtom(questionIdsAtom)
  const resetCustomerAttributeIds = useResetAtom(customerAttributeIdsAtom)
  const resetGroupNameMap = useResetAtom(groupNameMapAtom)
  const resetSequentialSortValue = useResetAtom(sequentialSortValueAtom)
  const resetIndividualSortValue = useResetAtom(individualSortValueAtom)
  const resetMatrixSortValue = useResetAtom(matrixSortValueAtom)
  const resetHiddenRowIds = useResetAtom(hiddenRowIdsAtom)
  const resetHiddenColumnKeys = useResetAtom(hiddenColumnKeysAtom)
  const resetGroupsDiffs = useResetAtom(groupsDiffsAtom)
  const resetQuestionsDiffsMap = useResetAtom(questionsDiffsMapAtom)
  const resetGroup = useResetAtom(groupAtom)
  const resetHighlightedCells = useResetAtom(highlightedCellAtom)

  const resetIsTabulationReady = useResetAtom(isTabulationReadyAtom)
  const resetIsPendingTabulation = useResetAtom(isPendingTabulationAtom)
  const resetTabulationQueryData = useResetAtom(tabulationQueryDataAtom)
  const resetLastTabulatedVariables = useResetAtom(lastTabulatedVariablesAtom)

  useUnmount(() => {
    resetComment()
    resetSavedComment()
    resetDataDisplayType()
    resetGroupInfos()
    resetResultViewerType()
    resetQuestionIds()
    resetCustomerAttributeIds()
    resetGroupNameMap()
    resetSequentialSortValue()
    resetIndividualSortValue()
    resetMatrixSortValue()
    resetHiddenRowIds()
    resetHiddenColumnKeys()
    resetGroupsDiffs()
    resetQuestionsDiffsMap()
    resetGroup()
    resetHighlightedCells()
    resetIsTabulationReady()
    resetIsPendingTabulation()
    resetTabulationQueryData()
    resetLastTabulatedVariables()
  })
}
